export const INTERNAL_CHAT_FOCUS_EVENT = 'bluezap:focus-internal-chat';
export const INTERNAL_CHAT_HEADER_SLOT_ID = 'internal-chat-header-slot';
export const INTERNAL_CHAT_LAUNCHER_POSITIONS = Object.freeze({
  NONE: 'none',
  BOTTOM_LEFT: 'bottom-left',
  HEADER: 'header',
});

const VALID_LAUNCHER_POSITIONS = new Set(Object.values(INTERNAL_CHAT_LAUNCHER_POSITIONS));

const normalizeTargetAttendantId = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

export const normalizeInternalChatLauncherPosition = (value) => {
  const normalized = String(value ?? '').trim().toLowerCase();
  if (normalized === 'bottom-right') {
    return INTERNAL_CHAT_LAUNCHER_POSITIONS.BOTTOM_LEFT;
  }
  if (VALID_LAUNCHER_POSITIONS.has(normalized)) {
    return normalized;
  }
  return INTERNAL_CHAT_LAUNCHER_POSITIONS.NONE;
};

export function openInternalChat({
  targetAttendantId = null,
  prefill = '',
} = {}) {
  if (typeof window === 'undefined') return false;

  const normalizedTargetAttendantId = normalizeTargetAttendantId(targetAttendantId);
  const normalizedPrefill = typeof prefill === 'string' ? prefill : '';

  window.dispatchEvent(
    new CustomEvent(INTERNAL_CHAT_FOCUS_EVENT, {
      detail: {
        attendantId: normalizedTargetAttendantId,
        targetId: normalizedTargetAttendantId,
        prefill: normalizedPrefill,
      },
    })
  );

  return true;
}
